import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postBPDataWithoutParams } from 'src/business/services'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { prospectContactIsEmpty, workforceContactIsEmpty } from 'src/consumer/helpers/utilFunctions'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import ClinicBrandOnboardingComponent from '../onboardng/clinicBrand/ClinicBrandOnboardingComponent'
import { BusinessOnboardingBody } from '../onboardng/ClinicOnboardingStyles'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getMPData, postMPData } from 'src/mentor/services'
import { getInviteObjectsForAllProspectsInBrand, sendInvitesToProspects } from './utils'

export default function ClinicBrandPeople() {
  const { clinicBrandId } = useParams()
  const { ownerData, refreshOwnerAssociatedClinicBrandsData } = useContext(ClinicDataContext)
  const [clinicBrandData, setClinicBrandData] = useState()
  const [loading, setLoading] = useState()
  const [teacherData, setTeacherData] = useState()
  const navigate = useNavigate()

  const thisClinicBrandData = ownerData?.associatedClinicBrandsData?.find(
    (item) => item?.id === clinicBrandId,
  )

  async function saveClinicBrandDetails() {
    setLoading(true)
    const dataToSubmit = {
      ...clinicBrandData,
      slug: clinicBrandData?.slug || clinicBrandData?.tempSlug || '',
      workforce: {
        ...clinicBrandData?.workforce,
        doctors:
          clinicBrandData?.workforce?.doctors?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
        therapists:
          clinicBrandData?.workforce?.therapists?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
        clinicAssistants:
          clinicBrandData?.workforce?.clinicAssistants?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
      },
      prospects: {
        ...clinicBrandData?.prospects,
        doctors:
          clinicBrandData?.prospects?.doctors?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
        therapists:
          clinicBrandData?.prospects?.therapists?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
        clinicAssistants:
          clinicBrandData?.prospects?.clinicAssistants?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
      },
    }

    const responseSaveProfile = await postBPDataWithoutParams(
      '/api/secure/cp/clinic-brand/save',
      dataToSubmit,
    )
    if (
      responseSaveProfile?.status === 200 &&
      isCommonResponseSuccessful(responseSaveProfile?.data?.code) &&
      responseSaveProfile?.data?.data?.['clinic-brand']
    ) {
      await Promise.all([
        refreshOwnerAssociatedClinicBrandsData(),
        // sendInvitesToProspects(responseSaveProfile?.data?.data?.['clinic-brand']),
      ])

      navigate(`/clinic-home/${clinicBrandId}`)
      toast.success('Details updated successfully')
    } else {
      toast.error('Error updating details')
    }
  }

  async function getAndSetDoctorDataInClinicBrand() {
    if (
      getAllRolesInBoolean().isDoctor ||
      getAllRolesInBoolean().isTeacher ||
      getAllRolesInBoolean().isCreator
    ) {
      const resp = await getMPData('/api/secure/teacher/profile')
      if (resp?.status === 200 && resp?.data) {
        if (Array.isArray(resp?.data?.categories) && resp?.data?.categories?.includes('doctor')) {
          setTeacherData(resp?.data)
        }
      }
    }
  }

  useEffect(() => {
    const doctorProspectEmailsToConsider =
      clinicBrandData?.attachedDoctorUserIds?.filter((item) => {
        return !thisClinicBrandData?.prospects?.doctors?.some((doctor) => doctor?.email === item)
      }) || []
    const therapistProspectEmailsToConsider =
      clinicBrandData?.attachedTherapistUserIds?.filter((item) => {
        return !thisClinicBrandData?.prospects?.therapists?.some(
          (therapist) => therapist?.email === item,
        )
      }) || []
    const clinicAssistantProspectEmailsToConsider =
      clinicBrandData?.attachedClinicAssistantUserIds?.filter((item) => {
        return !thisClinicBrandData?.prospects?.clinicAssistants?.some(
          (clinicAssistant) => clinicAssistant?.email === item,
        )
      }) || []

    setClinicBrandData({
      ...thisClinicBrandData,
      prospects: {
        doctors: [
          ...(thisClinicBrandData?.prospects?.doctors || []),
          ...doctorProspectEmailsToConsider?.map((item) => {
            return {
              email: item,
            }
          }),
        ],
        therapists: [
          ...(thisClinicBrandData?.prospects?.therapists || []),
          ...therapistProspectEmailsToConsider?.map((item) => {
            return {
              email: item,
            }
          }),
        ],
        clinicAssistants: [
          ...(thisClinicBrandData?.prospects?.clinicAssistants || []),
          ...clinicAssistantProspectEmailsToConsider?.map((item) => {
            return {
              email: item,
            }
          }),
        ],
      },
    })

    getAndSetDoctorDataInClinicBrand()
  }, [])

  useEffect(()=>{
    console.log({thisClinicBrandData})
  }, [thisClinicBrandData])

  return (
    <>
      <ClinicHeader
        heading={`${
          clinicBrandData?.brandName || clinicBrandData?.name || clinicBrandData?.title
        } | Brand People`}
      />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <BusinessOnboardingBody useMaxWidth maxWidth="768px">
        <ClinicBrandOnboardingComponent
          clinicBrand={clinicBrandData}
          setClinicBrand={setClinicBrandData}
          saveClinicBrand={saveClinicBrandDetails}
          savingClinicBrand={loading}
          editingProfileDetailsNotAllowed
          ownerData={ownerData}
          clinicBrandId={clinicBrandId}
          ownerUserData={ownerData?.userProfileData}
          teacherData={teacherData}
        />
      </BusinessOnboardingBody>
    </>
  )
}
